module.exports = __webpack_public_path__ + "static/media/Camera-block-img-3c.51893f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Camera-block-img-3c.png
// module id = 2507
// module chunks = 17